/** Electrical energy CN code excluded from supplier installation emission reports. */
export const SUPPLIER_INSTALLATION_EMISSION_REPORT_EXCLUDED_CN_CODE =
  '27160000'
